import type { RecordingPayload } from '@Application/Beneficiaries/Interviews/Actions/interviewsFetched';

export type RecordingCompletedAction = {
	type: 'RECORDING_COMPLETED';
	payload: RecordingPayload;
	interviewId: number;
	typeKey: string;
	subjectId: number;
};

export default (
	payload: RecordingPayload,
	interviewId: number,
	typeKey: string,
	subjectId: number,
): RecordingCompletedAction => ({
	type: 'RECORDING_COMPLETED',
	payload,
	interviewId,
	typeKey,
	subjectId,
});
